import SortableList from './SortableList.view';

export default SortableList;
